<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16.00030517578125"
    height="16"
    viewBox="0 0 16.00030517578125 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9.7027228125,7.30983C9.8782928125,7.48584,9.9953428125,7.7205200000000005,9.9953428125,7.99432C9.9953428125,8.26812,9.8880428125,8.51258,9.7124828125,8.68859C7.8238628125,10.59807,6.8200628125,11.60735,6.7010728125,11.71642C6.5225828125,11.880040000000001,6.2816628125,12,6.0085528125,12C5.4567728125,12,5.0108528125,11.55264,5.0108528125,11.01482C5.0108528125,10.741019999999999,5.1236528125,10.47358,5.3029828125,10.29412C5.4225328125,10.174489999999999,5.9273528125,9.74362,6.8174328125,9.00151C6.8174328125,9.00151,0.9802578125,9.00151,0.9802578125,9.00151C0.4438018125,9.00151,0.0048828125,8.53214,0.0048828125,7.99432C0.0048828125,7.45651,0.4438018125,6.99779,0.9802578125,6.99779C0.9802578125,6.99779,6.8174328125,6.99779,6.8174328125,6.99779C5.9218728125,6.24617,5.4170628125,5.81149,5.3029828125,5.69375C5.1318728125,5.5171399999999995,5.0108528125,5.26241,5.0108528125,4.988613C5.0108528125,4.450798,5.4639928125,4,6.0004528125,4C6.2735528125,4,6.5207728125,4.108119,6.6963428125,4.29391C6.8133828125,4.41777,7.8155128125,5.42308,9.7027228125,7.30983C9.7027228125,7.30983,9.7027228125,7.30983,9.7027228125,7.30983ZM13.0002828125,11.00192C11.3433828125,11.00192,10.0002628125,9.65537,10.0002628125,7.99432C10.0002628125,6.333270000000001,11.3433828125,4.98672,13.0002828125,4.98672C14.6570828125,4.98672,16.0002828125,6.333270000000001,16.0002828125,7.99432C16.0002828125,9.65537,14.6570828125,11.00192,13.0002828125,11.00192C13.0002828125,11.00192,13.0002828125,11.00192,13.0002828125,11.00192Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'FlowEnd',
} as DefineComponent
</script>
